import { useEffect, useState } from "react";
import { X } from "lucide-react";

export const ThemeHint = () => {
  const [visible, setVisible] = useState(false);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const show = setTimeout(() => {
      setIsDark(document.documentElement.dataset.theme === "dark");
      setVisible(true);
    }, 3000);
    return () => clearTimeout(show);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const auto = setTimeout(dismiss, 12000);
    return () => clearTimeout(auto);
  }, [visible]);

  function dismiss() {
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      data-testid="theme-hint"
      role="status"
      className="fixed top-24 right-4 md:right-10 z-50 max-w-[250px] bg-white border border-[#E5E5E5] shadow-[0_8px_30px_rgba(0,0,0,0.08)] rounded-md p-4"
    >
      <button
        type="button"
        onClick={dismiss}
        data-testid="theme-hint-close"
        aria-label="Zavřít tip"
        className="absolute top-2 right-2 p-1 text-[#737373] hover:text-[#B69A58] transition-colors duration-300"
      >
        <X className="h-4 w-4" strokeWidth={1.5} />
      </button>
      <p className="text-sm text-[#4A4A4A] leading-snug pr-4">
        {isDark
          ? "Chcete se přepnout do světlého režimu? Stačí kliknout na ikonu slunce v horní liště."
          : "Chcete se přepnout do tmavého režimu? Stačí kliknout na ikonu měsíce v horní liště."}
      </p>
      <button
        type="button"
        onClick={() => {
          window.dispatchEvent(new Event("theme-toggle-request"));
          dismiss();
        }}
        data-testid="theme-hint-switch"
        className="mt-3 text-xs uppercase tracking-widest font-medium text-[#B69A58] hover:text-[#8A6D2F] transition-colors duration-300"
      >
        Přepnout
      </button>
    </div>
  );
};
